// extracted by mini-css-extract-plugin
export var modal = "ModalYoutubeVideo-module--modal--LXjLF";
export var modal_content = "ModalYoutubeVideo-module--modal_content--UFiur";